import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=aa4b77f8&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=aa4b77f8&lang=sass&scoped=true&"
import style1 from "./MainTable.vue?vue&type=style&index=1&id=aa4b77f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4b77f8",
  null
  
)

export default component.exports